import jsPDF from "jspdf";
import "jspdf-autotable";

const generatePDFForVerticalTable = (headers, rows, isLandscape, title) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  // Set the date on the top left
  const currentDate = new Date().toLocaleDateString();
  //   doc.setFontSize(10);
  //   doc.text(currentDate, 14, 10); // Date aligned to the top left corner

  // Add title in the center
  doc.setFontSize(16);
  const pageWidth = doc.internal.pageSize.getWidth(); // Get page width for centering
  const textWidth = doc.getTextWidth(title);
  doc.text(title, (pageWidth - textWidth) / 2, 10); // Title centered

  // Generate the table using autoTable
  doc.autoTable({
    head: [headers], // Add headers as the first row
    body: rows, // Add rows as data
    startY: 20, // Start the table after the title and date
    styles: {
      fontSize: 10,
      halign: "left", // Align text to the left
    },
    theme: "grid",
    headStyles: {
      fillColor: null, // Removes header background color
      textColor: "black", // Ensures text is visible
    },
  });

  // Save the PDF
  doc.save(title + currentDate + ".pdf");
};

export default generatePDFForVerticalTable;
